import styled from "styled-components";
import {Modal, Form, Input} from "antd";

export const StyledModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 10px;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
        overflow: hidden;
    }

    .ant-modal-header {
        background: linear-gradient(135deg, #aeef01 0%, #9dd400 100%);
        border-bottom: none;
        padding: 20px 24px;
        border-radius: 10px 10px 0 0;

        .ant-modal-title {
            color: #000;
            font-weight: 600;
            font-size: 18px;
            margin: 0;
        }
    }

    .ant-modal-close {
        top: 16px;
        right: 16px;

        .ant-modal-close-x {
            color: #000;
            font-size: 16px;
            width: 32px;
            height: 32px;
            line-height: 32px;
            transition: all 0.3s ease;
            border-radius: 50%;

            &:hover {
                background-color: rgba(255, 255, 255, 0.2);
            }
        }
    }

    .ant-modal-body {
        padding: 24px;
        background: #fff;
    }

    .ant-modal-footer {
        border-top: 1px solid #f0f0f0;
        padding: 16px 24px;
        background: #fff;
        border-radius: 0 0 10px 10px;

        .ant-btn {
            height: 40px;
            border-radius: 6px;
            font-weight: 500;
            transition: all 0.3s ease;
        }

        .ant-btn-primary {
            background: #aeef01;
            border-color: #aeef01;
            color: #000;

            &:hover:not(:disabled) {
                background: #9dd400;
                border-color: #9dd400;
                transform: translateY(-1px);
                box-shadow: 0 4px 8px rgba(174, 239, 1, 0.3);
            }

            &:disabled {
                background: #f5f5f5;
                border-color: #d9d9d9;
                color: #bfbfbf;
            }
        }

        .ant-btn-default {
            border-color: #d9d9d9;
            color: #666;

            &:hover {
                border-color: #aeef01;
                color: #aeef01;
            }
        }
    }
`;

export const StyledForm = styled(Form)`
    .ant-form-item-label > label {
        font-weight: 500;
        color: #333;
        font-size: 14px;
    }
`;

export const StyledInput = styled(Input)`
    height: 44px;
    border-radius: 6px;
    font-size: 16px;
    transition: all 0.3s ease;

    &:focus,
    &:hover {
        box-shadow: 0 0 0 2px rgba(174, 239, 1, 0.1);
    }

    .ant-input-group-addon {
        background: #f8f8f8;
        border: 2px solid #e8e8e8;
        border-left: none;
        border-radius: 0 6px 6px 0;
        font-weight: 600;
        color: #666;
    }
`;

export const KdvInfoContainer = styled.div`
    margin-top: 20px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;
    border-left: 4px solid #aeef01;
`;

export const KdvRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${props => (props.isLast ? "0" : "8px")};

    .label {
        color: #666;
        font-size: 14px;
        font-weight: ${props => (props.isBold ? "600" : "400")};
    }

    .value {
        color: ${props => (props.isBold ? "#000" : "#333")};
        font-size: ${props => (props.isBold ? "16px" : "14px")};
        font-weight: ${props => (props.isBold ? "700" : "500")};
    }
`;

export const DividerLine = styled.div`
    height: 1px;
    background: #e8e8e8;
    margin: 12px 0;
`;
